// extracted by mini-css-extract-plugin
export default {"BlocRdvSupprime":"BlocRdvSupprime_BlocRdvSupprime__EqnpC"};